import React from "react";
import { Edit } from "react-admin";
import { EditActions } from "../../common/form/FormActions";
import { VehicleForm } from "./VehicleForm";
import { useNotification } from "../../../common/hooks/useNotification";
import { useFieldPermissions } from "../../../common/hooks/useFieldPermissions";
import { protectedEntities } from "../../../common/auth/permissions";
import { FieldPermissionsContext } from "../../common/field-permissions/FieldPermissionsContext";

interface IVehicleCreateProps {}

export const VehicleEdit = (props: IVehicleCreateProps) => {
  const notify = useNotification(props, "editSuccess");
  const fieldPermissions = useFieldPermissions(
    protectedEntities.Vehicle,
    (x) => x.edit
  );
  return (
    <FieldPermissionsContext.Provider value={fieldPermissions}>
      <Edit
        {...props}
        actions={<EditActions />}
        onSuccess={notify}
        title="resources.admin-vehicles.title.edit"
        transform={(data) => ({
          ...data,
          name: data.name.trim(),
        })}
      >
        <VehicleForm isEdit />
      </Edit>
    </FieldPermissionsContext.Provider>
  );
};
